import React, { useState } from 'react';
import '../../styles/ServiceFAQ.css';

interface FAQ {
  question: string;
  answer: string;
}

interface ServiceFAQProps {
  title?: string;
  faqs: FAQ[];
}

const ServiceFAQ: React.FC<ServiceFAQProps> = ({ 
  title = "Frequently Asked Questions", 
  faqs 
}) => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const toggleFAQ = (index: number) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(index)) {
      newExpandedItems.delete(index);
    } else {
      newExpandedItems.add(index);
    }
    setExpandedItems(newExpandedItems);
  };

  return (
    <section className="service-faq">
      <div className="service-faq-content">
        <h2>{title}</h2>
        
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${expandedItems.has(index) ? 'active' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={expandedItems.has(index)}
              >
                <span>{faq.question}</span>
                <span className={`faq-icon ${expandedItems.has(index) ? 'rotated' : ''}`}>
                  ▼
                </span>
              </button>
              
              <div className={`faq-answer ${expandedItems.has(index) ? 'expanded' : 'collapsed'}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFAQ; 